import { Component, EventEmitter, Input, OnChanges, Output, ViewChild, ViewContainerRef } from '@angular/core';

import { Block } from './julia-block.model';
import { BLOCK_VIEWS } from './block-registry';

/** Shows one block with the component registered for its kind. */
@Component({
  selector: 'app-julia-block-host',
  template: '<ng-container #slot></ng-container>',
})
export class JuliaBlockHostComponent implements OnChanges {
  @Input() block!: Block;
  @Input() sessionId!: string;
  @Output() expired = new EventEmitter<void>();
  @ViewChild('slot', { read: ViewContainerRef, static: true }) slot!: ViewContainerRef;

  ngOnChanges() {
    this.slot.clear();
    const view = BLOCK_VIEWS[this.block.kind];
    if (!view) return;
    const ref = this.slot.createComponent(view);
    ref.setInput('block', this.block);
    ref.setInput('sessionId', this.sessionId);
    ref.instance.expired.subscribe(() => this.expired.emit());
  }
}
